import classnames from 'classnames';
import { generateCompStylers } from '../../../../common/utils/styles';
import css from './FromControl.module.scss';
import { getPlaceholderColor } from '../helpers';

const FromControl = ({
    placeholder,
    placeholderError,
    children,
    compStyle,
    customCss = {},
    title,
    errors,
    required,
    val,
    focused,
    disabled,
    readonly
}) => {
    const { stylers, classes } = generateCompStylers(compStyle);
    const { stylers_custom, classes_custom } = generateCompStylers(customCss, '_custom');

    return (
        <div style={stylers_custom.wrapper} className={classnames(css.formControlContentPlaceholder, classes_custom.wrapper)}>
            {children}
            {!!placeholder && !val && (!focused || readonly) ? (
                <div
                    style={{
                        ...stylers_custom.inner,
                        ...stylers.placeholderWrapper
                    }}
                    className={classnames(css.formControlInnerPlaceholder, classes_custom.inner, classes.placeholderWrapper)}
                >
                    <div
                        style={{
                            ...getPlaceholderColor(stylers, errors, focused, disabled),
                            ...stylers.placeholder,
                            ...(errors ? stylers.placeholderError : {})
                        }}
                        className={classnames(css.placeholder, classes.placeholder, errors ? classes.placeholderError : '')}
                    >
                        {errors && placeholderError ? placeholderError : placeholder}
                    </div>
                    {!!required && !title && (
                        <p
                            style={{
                                ...stylers.requiredMark,
                                ...(!errors && focused ? stylers.requiredMarkFocus : {})
                            }}
                            className={classnames(
                                css.formControlRequiredMark,
                                classes.requiredMark,
                                !errors && focused ? [css.formControlRequiredMarkFocus, classes.requiredMarkFocus] : ''
                            )}
                        >
                            *
                        </p>
                    )}
                </div>
            ) : null}
        </div>
    );
};
export default FromControl;
